export default "__VITE_ASSET__79cad8d4__"